import {
    ERROR_PROPOSAL_DATE_INVALID,
    ERROR_PROPOSAL_UNCHECK,
    ERROR_MAXIMUM_PROPOSALID,
    ERROR_EMPTY_PROPOSALID,
    ERROR_EMPTY_PROPOSALNAME,
    ERROR_EMPTY_PRICEDISPLAY,
    ERROR_STARTDATE_FORMAT,
    ERROR_ENDDATE_FORMAT,
    ERROR_CHAR_PROPOSALID,
    ERROR_EMPTY_PATTERN,
    ERROR_EMPTY_TIME,
    ERROR_STARTDATE_EMPTY,
    ERROR_NEGATIVE_PRICEDISPLAY
} from "../../../../utils/messages";
import {
    EMPTY_COUNT,
    REGEX_DATE_SAVE,
    SINGLE_RECORD,
    REGEX_HALF_WIDTH,
    MIN_DB_DATE,
    MAX_DB_DATE,
    MIN_DB_DATE_EXACT,
    MAX_DB_DATE_EXACT,
    DATE_FORMAT
} from "../../../../utils/constants";
import moment from 'moment';
import { isNullOrEmpty } from "../../../../utils/common";

function validate(payload) {
    let prompt = [];
    let isStartDateValid = true;
    let isEndDateValid = true;

    if (EMPTY_COUNT === payload.checkboxItems.length) {
        prompt.push(ERROR_PROPOSAL_UNCHECK);
    }

    if (!payload.startDate.match(REGEX_DATE_SAVE) || !moment(payload.startDate, DATE_FORMAT).isValid()) {
        prompt.push(ERROR_STARTDATE_FORMAT);
        isStartDateValid = false;
    }

    if (!payload.endDate.match(REGEX_DATE_SAVE) || !moment(payload.endDate, DATE_FORMAT).isValid()) {
        prompt.push(ERROR_ENDDATE_FORMAT);
        isEndDateValid = false;
    }

    if (isStartDateValid && isEndDateValid) {
        if (moment(payload.startDate) > moment(payload.endDate)) {
            prompt.push(ERROR_PROPOSAL_DATE_INVALID);
        }

        if(moment(payload.endDate) < moment(MAX_DB_DATE) && moment(payload.startDate) <= moment(MIN_DB_DATE)){
            prompt.push(ERROR_STARTDATE_EMPTY);
        }
    }

    return prompt;
}

function validateForm(payload) {

    let prompt = [];
    let MAX_ID_LENGTH = 3;

    if (isNullOrEmpty(payload.proposalId)) {
        prompt.push(ERROR_EMPTY_PROPOSALID);
    } else {
        if (MAX_ID_LENGTH < payload.proposalId.length) {
            prompt.push(ERROR_MAXIMUM_PROPOSALID);
        }else if (!payload.proposalId.match(REGEX_HALF_WIDTH)) {
            prompt.push(ERROR_CHAR_PROPOSALID);
        }
    }

    if (isNullOrEmpty(payload.proposalName)) {
        prompt.push(ERROR_EMPTY_PROPOSALNAME);
    }

    if (!payload.proposalStartDate.match(REGEX_DATE_SAVE) || !moment(payload.proposalStartDate, DATE_FORMAT).isValid()) {
        prompt.push(ERROR_STARTDATE_FORMAT);
    }

    if (!payload.proposalEndDate.match(REGEX_DATE_SAVE) || !moment(payload.proposalEndDate, DATE_FORMAT).isValid()) {
        prompt.push(ERROR_ENDDATE_FORMAT);
    }

    if (payload.proposalStartDate.match(REGEX_DATE_SAVE) && payload.proposalEndDate.match(REGEX_DATE_SAVE)) {
        if (moment(payload.proposalStartDate) > moment(payload.proposalEndDate)) {
            prompt.push(ERROR_PROPOSAL_DATE_INVALID);
        }

        if(moment(payload.proposalEndDate) < moment(MAX_DB_DATE_EXACT) && moment(payload.proposalStartDate) <= moment(MIN_DB_DATE_EXACT)){
            prompt.push(ERROR_STARTDATE_EMPTY);
        }
    }

    if (isNullOrEmpty(payload.displayPrice)) {
        prompt.push(ERROR_EMPTY_PRICEDISPLAY);
    }

    if(isNullOrEmpty(payload.deadlineHour) || isNullOrEmpty(payload.deadlineMinute)){
        prompt.push(ERROR_EMPTY_TIME);
    }

    return prompt;
}

function hourSubtstring(payload) {
    let hourStartIndex = 0;
    let hourEndIndex = 2;

    return payload.substring(hourStartIndex, hourEndIndex);
}

function minSubtstring(payload) {
    let minuteStartIndex = 2;
    let minuteEndIndex = 4;

    return payload.substring(minuteStartIndex, minuteEndIndex);
}

function checkPartnerDuplicate(state) {
    let completePartners = [];

    state.map((item) =>
        item.partners.map((partner) =>
            completePartners.push(partner)
        )
    )

    for (let i = EMPTY_COUNT; i < completePartners.length; i++) {
        let count = completePartners.filter((item) =>
            item.customerCode1 === completePartners[i].customerCode1 && item.customerCode2 === completePartners[i].customerCode2).length;
        if (SINGLE_RECORD < count) {
            return true;
        }
    }

    return false;
}

function validateProductTable(state){
    let prompt = [];

    let emptyPatternCount = state.filter((product)=>isNullOrEmpty(product.orderControlCode)).length;
    let negativePatternCount = state.filter((product)=> (null !== product.productPrice && EMPTY_COUNT > product.productPrice)).length;

    if(EMPTY_COUNT < emptyPatternCount){
        prompt.push(ERROR_EMPTY_PATTERN)
    }

    if(EMPTY_COUNT < negativePatternCount){
        prompt.push(ERROR_NEGATIVE_PRICEDISPLAY)
    }

    return prompt;
}

function validateAddPartnerForm(payload){
    let prompt = [];

    if (!payload.proposalStartDate.match(REGEX_DATE_SAVE)) {
        prompt.push(ERROR_STARTDATE_FORMAT);
    }

    if (!payload.proposalEndDate.match(REGEX_DATE_SAVE)) {
        prompt.push(ERROR_ENDDATE_FORMAT);
    }

    if (payload.proposalStartDate.match(REGEX_DATE_SAVE) && payload.proposalEndDate.match(REGEX_DATE_SAVE)) {
        if (moment(payload.proposalStartDate) > moment(payload.proposalEndDate)) {
            prompt.push(ERROR_PROPOSAL_DATE_INVALID);
        }
    }

    return prompt;
}

export {
    validate,
    validateForm,
    hourSubtstring,
    minSubtstring,
    checkPartnerDuplicate,
    validateProductTable,
    validateAddPartnerForm
};